import { render, staticRenderFns } from "./RestoreDraftModal.vue?vue&type=template&id=4497a128&scoped=true"
import script from "./RestoreDraftModal.vue?vue&type=script&lang=js"
export * from "./RestoreDraftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497a128",
  null
  
)

export default component.exports